import React, { useState, useEffect, useContext } from "react";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import EditMeetingForm from "components/brandActivation/editMeetingForm/editmeetingform";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useParams } from "react-router-dom";
import Regex from "services/utils/regex/Regex";
import parse from "html-react-parser";
import ErrModalPop from "components/sales/modal/errorModal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { handleValidateObj } from "constants/objValues/objvalues";
import { validateObject } from "constants/objValues/validateObject";
import useLatLng from "hooks/uselatlng/uselatlng";
import {getSiteFilters} from "../../../../services/redux/installation/siteListing/action";
import {
  isLertAssessmentAgenda,
  isLertAssessmentFormReady,
  buildLertAssessmentMeetingPayload,
} from "components/brandActivation/meetingSalesSubSubject";

const SaveAsDraft = ({
  pocList,
  getPocList,
  createMeeting,
  updateMeeting,
  match,
  history,
  meetingById = null,
  getMeetingById,
  getCorpClientList,
  corpClientList,
  getCorpPocList,
  documentUploadUrl,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  corpClientPoc,
  getInvoiceList,
  invoiceList,
  getBaOpportunityFromLeadx,
  opportunityList = [],
  saveDraftMeeting,
  getSaveAsDraftData,
  getDraftEditData = [],
  discardDraftMeeting,
  getSiteFilters,
  siteFilters=[]
}) => {
  const { id } = useParams();
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [teamId, setTeamId] = useState();
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const [viewMeeting, setViewMeeting] = useState({});
  const [errorMsg, setIsErrorMsg] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [meetingId, setMeetingId] = useState(null);
  const islatlng = useLatLng();
  const [isAllow, setIsAllow] = useState(false);
  const [draftModalVisible, setDraftModalVisible] = useState(false);
  const [discardModalVisible, setDiscardModalVisible] = useState(false);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });
  const [role, setRoleId] = useState('')
  const [distance, setDistance] = useState()

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  const handleForm = (val) => {
    if (val && isLertAssessmentAgenda(val?.subject)) {
      setCorporateData({
        ...meetingData,
        meetingDetails: buildLertAssessmentMeetingPayload(val, {
          id: val.id,
          lat: val.lat,
          lng: val.lng,
          selfieUrl: val.selfieUrl,
          contract_poc_data: val.contract_poc_data,
          role_id: val.role_id,
        }),
      });
      return;
    }

    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  const handleSubmit = () => {
    // console.log('Meeting Details Vms:', meetingData);
    // return false;
    const { meetingDetails } = meetingData;
    meetingDetails['role_id'] = role
    let isNotEmpty = true;
    const isLertAssessment = isLertAssessmentAgenda(meetingDetails?.subject);
    const isFormComplete = isLertAssessment
      ? isLertAssessmentFormReady(meetingDetails)
      : meetingDetails?.body !== "";
    if (
      meetingDetails !== null &&
      meetingDetails?.subject !== "" &&
      isFormComplete
    ) {
      if (isLertAssessment) {
        if (!String(meetingDetails?.body || "").trim()) {
          toast.error("Please fill meeting description");
          return false;
        }
        if (!meetingDetails?.risk_category) {
          toast.error("Please select Risk Category");
          return false;
        }
        if (!meetingDetails?.churn_risk) {
          toast.error("Please select Churn Risk");
          return false;
        }
        if (
          meetingDetails?.risk_category === "Other" &&
          !String(meetingDetails?.risk_category_other || "").trim()
        ) {
          toast.error("Please enter Risk Category details");
          return false;
        }
      }

      const otherSiteId = meetingDetails?.other_site_id;
      const hasOtherSiteId =
        otherSiteId !== null &&
        otherSiteId !== undefined &&
        otherSiteId !== "" &&
        Number(otherSiteId) !== 0;
      const siteId = Number(meetingDetails?.site_id);
      const isOtherClient =
        siteId === -1 || (siteId === 0 && !hasOtherSiteId);
      if (isOtherClient) {
        const clientEmail = String(
          meetingDetails?.other_client_email || ""
        ).trim();
        if (!clientEmail || !Regex.email.test(clientEmail)) {
          toast.error(
            !clientEmail
              ? localization.emailAddressRequired
              : localization.emailError
          );
          return false;
        }
      }

      if (meetingDetails?.subject === "Payment Collection Meeting") {
        if (meetingDetails?.paymentPicked == "") {
          toast.error("Please fill payment picked");
          return false;
        }
        if (meetingDetails?.paymentPicked === "Yes") {
          if (meetingDetails?.paymentMode == "") {
            toast.error("Please fill payment mode");
            return false;
          }
          if (meetingDetails?.saleType == "") {
            toast.error("Please select sale type");
            return false;
          }
          if (meetingDetails?.saleType === "New Sale") {
            meetingDetails?.inputIteration.map((val, index) => {
              if (!validateObject(val)) {
                isNotEmpty = false;
                toast.error("Please fill all payment details!");
              }
            });
          } else {
            meetingDetails?.inputIteration.map((val, index) => {
              if (!handleValidateObj(val)) {
                isNotEmpty = false;
                toast.error(
                  "Please fill all payment details along with attachment!"
                );
              }
            });
          }
        } else if (meetingDetails?.paymentPicked === "No") {
          if (meetingDetails.chequeRemark === "") {
            toast.error("Please fill reason for not picking cheque!");
            return false;
          }
        }
      }

      if(window.localStorage.upselling_oppor){
        meetingDetails['existing_upselling_opportunity'] = JSON.parse(window.localStorage.upselling_oppor)
        delete window.localStorage.upselling_oppor
      }
      setIsFiled(false);
      if (isNotEmpty !== false) {
        const payload = isLertAssessmentAgenda(meetingDetails?.subject)
          ? buildLertAssessmentMeetingPayload(meetingDetails, {
              role_id: role,
              selfieUrl: meetingDetails?.selfieUrl,
              lat: meetingDetails?.lat,
              lng: meetingDetails?.lng,
              contract_poc_data: meetingDetails?.contract_poc_data,
            })
          : { ...meetingDetails, role_id: role };

        (async () => {
          setIsLoading(true);
          const res = await (id
            ? updateMeeting(payload)
            : createMeeting(payload, 2, match.params.draft_id));
          setIsLoading(false);
          if (res) {
            // console.log(res);
            if (res.data) {
              setMeetingId(res.data.id);
              setSiteId(res.data?.site_id);
            }
            setIsModal(true);
          }
        })();
      }
    } else {
      var errMsg = "ERROR!";
      if (meetingDetails?.client === "") {
        errMsg = errMsg + "Client name Is Required!<br/>";
      }
      if (meetingDetails?.subject === "") {
        errMsg = errMsg + "Subject Is Required! <br/>";
      }
      if (meetingDetails?.body === "") {
        errMsg = errMsg + "Summary Is Required! <br/>";
      }
      if (isLertAssessment) {
        if (!meetingDetails?.risk_category || !meetingDetails?.churn_risk) {
          errMsg = errMsg + "Risk Category and Churn Risk are required! <br/>";
        } else if (
          meetingDetails?.risk_category === "Other" &&
          !String(meetingDetails?.risk_category_other || "").trim()
        ) {
          errMsg =
            errMsg + "Risk Category details are required! <br/>";
        }
      }

      setIsErrorMsg(errMsg);
      setIsErrorModal(true);
      setIsFiled(true);
      setIsModal(false);
      return false;
    }
  };

  useEffect(() => {
    if (
      mapLocation?.lat &&
      mapLocation?.lat !== null &&
      getCorpClientList !== null
    )
      (async () => {
        setIsLoading(true);
        await getCorpClientList(
          match.params.siteId,
          mapLocation?.lat,
          mapLocation?.lng
        );
        setIsLoading(false);
      })();
  }, [getCorpClientList, match.params.siteId, mapLocation?.lat]);

  useEffect(() => {
    (async () => {
      delete window.localStorage.upselling_oppor
      setRoleId(localStorage.getItem("fusion-role"))
      const data = await localStorage.getItem("viewDetail");
      await getSiteFilters()
      if (data && data !== "undefined" && data.length) {
        const team =
          data.length && JSON.parse(data) ? JSON.parse(data)[0]?.lead_type : "";
        setTeamId(team);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (id) {
        setIsLoading(true);
        let viewData = await getMeetingById(id);
        if (viewData) setViewMeeting({ ...viewData });
        setIsLoading(false);
      }
    })();
  }, [getMeetingById, id]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSaveAsDraftData(match.params.draft_id);
      setIsLoading(false);
    })();
  }, [getSaveAsDraftData]);

  // const handleModalHide = () => {
  //   setIsModal(false);
  //   history.push(`${baseUrl}/brand-activation/scheduled-meeting`);
  // };

  const handleDraft = () => {
    const { meetingDetails } = meetingData;
    const payload = isLertAssessmentAgenda(meetingDetails?.subject)
      ? buildLertAssessmentMeetingPayload(meetingDetails, {
          role_id: role,
          selfieUrl: meetingDetails?.selfieUrl,
          lat: meetingDetails?.lat,
          lng: meetingDetails?.lng,
          contract_poc_data: meetingDetails?.contract_poc_data,
        })
      : { ...meetingDetails, role_id: role };

    (async () => {
      // return false;
      setIsLoading(true);
      const res = await saveDraftMeeting(payload);
      if (res) {
        setIsModal(true);
      } else {
        var errMsg = "Something went wrong!";
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsFiled(true);
        setIsModal(false);
        return false;
      }
      setIsLoading(false);
      setDraftModalVisible(true);
    })();
  };

  const discardDraft = () => {
    (async () => {
      setIsLoading(true);
      const res = await discardDraftMeeting();
      if (res) {
        setIsModal(true);
      } else {
        var errMsg = "Something went wrong!";
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsFiled(true);
        setIsModal(false);
        return false;
      }
      setIsLoading(false);
      setDiscardModalVisible(true);
    })();
  };

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/brand-activation/scheduled-meeting`);
  };

  const handleDraftModalHide = () => {
    setDraftModalVisible(false);
  };

  const handleDiscardModalHide = () => {
    setDiscardModalVisible(false);
  };

  const headerBtns = () => {
    const { meetingDetails } = meetingData;
    return (
      <>
        {/*{console.log('meetingDetails:', meetingDetails)}*/}
        {meetingDetails?.subject && (
          <>
            {/* <Button onClick={discardDraft} className="btn btn-danger">
              {localization.removeDraft}
            </Button> */}
            <Button onClick={handleDraft} className="btn btn-primary">
              {localization.saveDraft}
            </Button>
          </>
        )}
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submit}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </>
    );
  };

  const toRad = (Value) => {
      return Value * Math.PI / 180
  }

  const calcCrow = (lat1, lon1, lat2, lon2) => {
      var R = 6371 // km
      var dLat = toRad(lat2 - lat1)
      var dLon = toRad(lon2 - lon1)
      var lat1 = toRad(lat1)
      var lat2 = toRad(lat2)

      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c
      return d
  }

  useEffect(() => {
    if(getDraftEditData?.is_geo_location_on){
      let distance = calcCrow(getDraftEditData?.latitude, getDraftEditData?.longitude, islatlng?.lat, islatlng?.lng)
              distance = parseFloat(distance).toFixed(2);
              if( parseInt(getDraftEditData?.geo_location_range) < parseInt(distance)){
                toast.warning("Your are "+distance+" meter away from your check in location.")
                  setTimeout(() => {
                    window.location.href = `${baseUrl}/brand-activation/scheduled-meeting`
                  }, 1000)
              }
    }
  }, [getDraftEditData])

  const handleModalHide1 = () => setIsErrorModal(false);

  return (
    <Layout
      title={localization.scheduleMeeting}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
    >
      <EditMeetingForm
        pocList={pocList}
        handleValue={handleForm}
        saveAsDraft={handleDraft}
        siteId={siteId}
        meetingById={id ? meetingById : null}
        teamId={teamId}
        documentUploadUrl={documentUploadUrl}
        documentUploadUrlPublic={documentUploadUrlPublic}
        documentUrlDataPublic={documentUrlDataPublic}
        corpClientList={corpClientList}
        getCorpPocList={getCorpPocList}
        corpClientPoc={corpClientPoc}
        viewMeeting={viewMeeting}
        getInvoiceList={getInvoiceList}
        invoiceList={invoiceList}
        getBaOpportunityFromLeadx={getBaOpportunityFromLeadx}
        opportunityLis={opportunityList}
        draftData={getDraftEditData}
        getCorpClientList={getCorpClientList}
        siteFilters={siteFilters}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingTrackSuccess}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.goToMeetingList}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
          &nbsp;
          {meetingId && siteId ? (
            <Link
              to={`${baseUrl}/brand-activation/create-mom/${siteId}/${meetingId}`}
              className="btn btn-primary mb-4"
            >
              {localization.createMom}{" "}
            </Link>
          ) : null}
          &nbsp;
          <Link
              to={`${baseUrl}/ncs-meetings`}
              className="btn btn-primary mb-4"
            >
              {localization.ncsMeetings}{" "}
          </Link>
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">{parse(errorMsg)}</div>
      </ErrModalPop>

      {/* draft modal starts*/}
      <ModalPop
        title={localization.conf}
        show={draftModalVisible}
        handleModalHide={handleDraftModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.dataSavedAsDraft}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.goToMeetingList}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
          &nbsp;
          {meetingId && siteId ? (
            <Link
              to={`${baseUrl}/brand-activation/create-mom/${siteId}/${meetingId}`}
              className="btn btn-primary mb-4"
            >
              {localization.createMom}{" "}
            </Link>
          ) : null}
        </div>
      </ModalPop>

      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">{parse(errorMsg)}</div>
      </ErrModalPop>

      <ModalPop
        title={localization.conf}
        show={discardModalVisible}
        handleModalHide={handleDiscardModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.draftDiscarded}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.goToMeetingList}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
          &nbsp;
          {meetingId && siteId ? (
            <Link
              to={`${baseUrl}/brand-activation/create-mom/${siteId}/${meetingId}`}
              className="btn btn-primary mb-4"
            >
              {localization.createMom}{" "}
            </Link>
          ) : null}
        </div>
      </ModalPop>

      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">{parse(errorMsg)}</div>
      </ErrModalPop>
      {/* draft modal ends*/}
    </Layout>
  );
};

SaveAsDraft.propTypes = {};

export default SaveAsDraft;
